<template>
  <div>
    <!-- Apartado de importación (misma mecánica que el importador de órdenes de trabajo) -->
    <b-collapse class="mb-4" animation="slide" :open="importOpen" @open="importOpen = true" @close="importOpen = false">
      <template #trigger="props">
        <div class="flex items-center gap-2 cursor-pointer text-blue mb-2">
          <b-icon pack="fas" :icon="props.open ? 'angle-down' : 'angle-right'"></b-icon>
          <b-icon pack="fas" icon="file-import"></b-icon>
          <span class="font-medium">{{ $t('import') }}</span>
        </div>
      </template>
      <import-entities
        :can-overwrite="false"
        :project-id="projectId"
        :with-history="false"
        entity-type="backcharges"
        @success="load"
      />
    </b-collapse>

    <!-- Añadir -->
    <div class="flex justify-end mb-4">
      <b-button type="is-primary" size="is-small" icon-left="plus" icon-pack="fas" @click="openAdd">
        {{ $t('add_backcharge') }}
      </b-button>
    </div>

    <b-table :data="backcharges" :loading="isLoading" hoverable striped icon-pack="fas" class="text-sm">
      <b-table-column field="line_item" :label="$t('line_item')" width="200" v-slot="props">
        {{ props.row.line_item || '-' }}
      </b-table-column>

      <b-table-column field="description" :label="$t('description')" v-slot="props">
        {{ props.row.description || '-' }}
      </b-table-column>

      <b-table-column field="actions" :label="$t('actions')" width="100" centered v-slot="props">
        <b-tooltip :label="$t('edit')" position="is-left">
          <b-button type="is-text" size="is-small" icon-left="pen" icon-pack="fas"
            class="text-gray-500 hover:text-blue" @click="openEdit(props.row)"></b-button>
        </b-tooltip>
        <b-tooltip :label="$t('delete')" position="is-left">
          <b-button type="is-text" size="is-small" icon-left="trash" icon-pack="fas"
            class="text-gray-500 hover:text-red-600" @click="confirmDelete(props.row)"></b-button>
        </b-tooltip>
      </b-table-column>

      <template #empty>
        <div class="has-text-centered py-8">
          <p class="text-gray-500">{{ isLoading ? $t('loading') : $t('no_results') }}</p>
        </div>
      </template>
    </b-table>

    <!-- Modal añadir / editar -->
    <b-modal v-model="isModalActive" has-modal-card :width="520" scroll="keep">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ form.id ? $t('edit') : $t('add_backcharge') }}</p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$t('line_item')">
            <b-input v-model="form.lineItem" maxlength="255"></b-input>
          </b-field>
          <b-field :label="$t('description')">
            <b-input v-model="form.description" type="textarea" rows="3"></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <b-button size="is-small" @click="isModalActive = false">{{ $t('cancel') }}</b-button>
          <b-button type="is-primary" size="is-small" :loading="isSaving" @click="save">{{ $t('save') }}</b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import ImportEntities from '../import-entities.vue';

export default {
  name: 'BackchargesManage',

  components: {
    ImportEntities,
  },

  props: {
    projectId: { type: Number, required: true },
  },

  data: () => ({
    backcharges: [],
    isLoading: false,
    importOpen: false,
    isModalActive: false,
    isSaving: false,
    form: { id: null, lineItem: '', description: '' },
  }),

  created() {
    this.load();
  },

  methods: {
    async load() {
      this.isLoading = true;
      try {
        const { data } = await axios.get(`/api/v2/project/${this.projectId}/backcharges`);
        if (data && data.success) {
          this.backcharges = data.data || [];
        }
      } catch (e) {
        this.$notify.error('error_loading_data');
      } finally {
        this.isLoading = false;
      }
    },

    openAdd() {
      this.form = { id: null, lineItem: '', description: '' };
      this.isModalActive = true;
    },

    openEdit(row) {
      this.form = { id: row.id, lineItem: row.line_item, description: row.description };
      this.isModalActive = true;
    },

    async save() {
      this.isSaving = true;
      try {
        const payload = { line_item: this.form.lineItem, description: this.form.description };
        let data;
        if (this.form.id) {
          ({ data } = await axios.put(`/api/v2/project/${this.projectId}/backcharges/${this.form.id}`, payload));
        } else {
          ({ data } = await axios.post(`/api/v2/project/${this.projectId}/backcharges`, payload));
        }
        if (data && data.success) {
          this.$notify.success('success');
          this.isModalActive = false;
          this.load();
        } else {
          this.$notify.error('error');
        }
      } catch (e) {
        this.$notify.error('error');
      } finally {
        this.isSaving = false;
      }
    },

    confirmDelete(row) {
      this.$buefy.dialog.confirm({
        title: this.$t('delete'),
        message: this.$t('are_you_sure'),
        confirmText: this.$t('delete'),
        cancelText: this.$t('cancel'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.remove(row),
      });
    },

    async remove(row) {
      try {
        const { data } = await axios.delete(`/api/v2/project/${this.projectId}/backcharges/${row.id}`);
        if (data && data.success) {
          this.$notify.success('success');
          this.load();
        } else {
          this.$notify.error('error');
        }
      } catch (e) {
        this.$notify.error('error');
      }
    },
  },
};
</script>
